import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ts_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      localStorage.removeItem("ts_token");
      localStorage.removeItem("ts_user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function apiError(err, fallback = "Ha ocurrido un error") {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d?.reasons) && d.reasons.length)
    return d.reasons.map((r) => r?.message || r?.code).filter(Boolean).join(" · ");
  if (d.message) return d.message;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return fallback;
}

export function ruleReasons(err) {
  const d = err?.response?.data?.detail;
  if (d && typeof d === "object" && Array.isArray(d.reasons)) return d.reasons;
  return null;
}

export default api;
